(function ($) {

  let $cart = $('.cart-flyout');
  $cart.click(() => {
    let $nr = $('.cart-block--summary__count').text();
    if ($nr === "0") {
      alert("Ga naar 'Webwinkel' om producten toe te voegen.");
    }
  });

})(jQuery, Drupal);
